export { addObjectProperties as addObjectProperties } from './addObjectProperties'
export { addProperty } from './addProperty'
export { cacheProperties } from './cacheProperties'
export { type CompositeProxyLayer, createCompositeProxy } from './createCompositeProxy'
export { removeProperties } from './removeProperties'
